import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';
import { Price } from '@sm360/widget-commons-tiles';

import './PriceDescription.scss';

class PriceDescription extends Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const { msrp, freightPDI, taxesAndDuties, total } = this.props.price;
        return (
            <div className="vehicle-description clearfix">
                <div className="vehicle-name">
                    {this.props.modelDescription}
                    <span className="vehicle-body">{this.props.modelBodyStyle}</span>
                </div>
                <div className="vehicle-cost">
                    <div>
                        <span className="vehicle-price-label sr-text is-bold highlight">
                            {LocaleService.t('TILE_A.MSRP')}
                        </span>
                        <span className="vehicle-price vehicle-msrp is-bold highlight">
                            {LocaleService.l(msrp, CurrencyFormats.CURRENCY_0)}
                        </span>
                    </div>
                    <div>
                        <span className="vehicle-price-label">{LocaleService.t('TILE_A.FREIGHT_PDI')}</span>
                        <span className="vehicle-price vehicle-freight-pdi">
                            {LocaleService.l(freightPDI, CurrencyFormats.CURRENCY_0)}
                        </span>
                    </div>
                    <div>
                        <span className="vehicle-price-label">{LocaleService.t('TILE_A.TAXES_AND_DUTIES')}</span>
                        <span className="vehicle-price vehicle-taxes-and-duties">
                            {LocaleService.l(taxesAndDuties, CurrencyFormats.CURRENCY_0)}
                        </span>
                    </div>
                    <div className="vehicle-price-total">
                        <span className="vehicle-price-label">{LocaleService.t('TILE_A.STARTING_AT')}</span>
                        <span className="vehicle-price vehicle-total">
                            {LocaleService.l(total, CurrencyFormats.CURRENCY_0)}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

PriceDescription.propTypes = {
    modelDescription: PropTypes.string.isRequired,
    modelBodyStyle: PropTypes.string.isRequired,
    price: PropTypes.instanceOf(Price).isRequired,
};

PriceDescription.displayName = 'PriceDescription';

export default PriceDescription;
